<template>
  <el-dialog
    v-if="response"
    title="ИНФОРМАЦИЯ ПО ТТН"
    class="ttn-block"
    :append-to-body="true"
    :visible="!!response"
    :width="isMobile ? '95%' : '70%'"
    :close-on-click-modal="false"
    top="3vh"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-row v-if="response.auto" class="plates">
      <span>Авто: {{ response.auto.state_numbers || 'Н/Д' }}</span>
      <span>Прицеп: {{ response.auto.state_numbers_trailer || 'Н/Д' }}</span>
    </el-row>
    <loader-wrapper :loading="loading">
      <el-row
        v-if="invoices.length"
        type="flex"
        align="middle"
        class="ttn-labels"
      >
        <el-col
          v-for="(invoice, i) in invoices"
          :key="invoice.id"
          class="w-auto mr-10"
        >
          <el-button
            type="text"
            :disabled="i === index"
            class="add-ttn"
            @click="setTTN(i)"
          >
            ТТН №{{ invoice.number || 'Н/Д' }} от
            {{ dateToFormat(invoice.date, 'defaultDateRu') || 'Н/Д' }}
          </el-button>
        </el-col>
        <el-col v-if="!hardwareType" class="w-auto">
          <el-button
            type="text"
            :disabled="index === -1"
            class="add-ttn"
            @click="addTTN"
          >
            Добавить еще одну ТТН
          </el-button>
        </el-col>
      </el-row>
      <el-row v-else class="no-ttn">
        НЕТ ТТН. Заполните форму и сохраните данные
      </el-row>
      <form-ttn
        :ttn="index >= 0 ? invoices[index] : null"
        :response-id="response.id"
        :shortage="shortage"
        :load-date="loadDate"
        :default-type="type"
        :hardware-type="hardwareType"
        @invoices="setInvoices"
        @loading="setLoading"
        v-on="$listeners"
      />
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import FormTtn from '../Forms/FormTTN'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'ModalTTN',
  components: { FormTtn, LoaderWrapper },
  props: {
    response: {
      type: Object,
      default: () => null,
    },
    shortage: {
      type: Object,
      default: () => {},
    },
    loadDate: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    hardwareType: {
      type: String,
      default: '',
    },
    defaultTtnId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      index: -1,
      invoices: [],
      loading: false,
    }
  },
  methods: {
    beforeOpen() {
      this.index = -1
    },
    beforeClose() {
      this.$emit('close')
    },
    addTTN() {
      this.index = -1
    },
    setTTN(i) {
      this.index = i
    },
    setLoading(val = false) {
      this.loading = val
    },
    setInvoices(invoices, flag) {
      this.invoices = invoices

      if (flag > -2 && this.invoices.length) {
        if (flag === 0 && this.invoices.length > 1 && this.defaultTtnId > 0) {
          const index = this.invoices.findIndex(i => i.id === this.defaultTtnId)

          if (index !== -1) {
            flag = index
          }
        }
        this.setTTN(flag)
      }
    },
  },
}
</script>

<style lang="sass">
.ttn-block
  *
    font-family: 'Rubik', sans-serif
  .el-dialog__body, .el-dialog__title
    font-size: 18px
    color: #000000
  .el-input__inner
    height: auto
  .ttn-labels
    flex-wrap: wrap
    .el-button
      font-size: 18px
  .plates
    font-size: 14px
    margin-bottom: 15px
    span:last-child
      margin-left: 10px
  .no-ttn
    color: #FF0000
  .add-ttn
    padding: 0
    border-bottom: 1px solid
    border-radius: 0
    &.el-button.is-disabled, &.el-button.is-disabled:focus, &.el-button.is-disabled:hover
      color: #000000
</style>
